import { render, staticRenderFns } from "./CurationProductsTable.vue?vue&type=template&id=d84e0574"
import script from "./CurationProductsTable.vue?vue&type=script&lang=js"
export * from "./CurationProductsTable.vue?vue&type=script&lang=js"
import style0 from "./CurationProductsTable.vue?vue&type=style&index=0&id=d84e0574&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports